import _ from 'lodash';

export default function money(cents) {
  const amount = (cents / 100).toFixed(2);
  const segments = amount.split('.');
  let dollars: string|number = parseInt(segments[0], 10);
  if (_.isFunction(dollars.toLocaleString)) {
    dollars = dollars.toLocaleString();
  }
  return `${dollars}.${segments[1]}`;
}
